import {DynamicPageParameters} from '_types'
import {analyticsLogEvent} from '../api'

const eventName = 'dynamic_page'

/**
 * Logs a `dynamic_page` event to the analytics system with contextual metadata.
 *
 * This function builds an event object from the provided parameters,
 * removes any fields with `undefined` values to keep the payload clean,
 * and then logs the event using the `analyticsLogEvent` function.
 *
 * @param {DynamicPageParameters} params - Parameters describing the dynamic page context.
 * @param {string} params.category - High-level category of the page.
 * @param {string} [params.subCategory] - Optional subcategory of the page.
 * @param {string} [params.pageDetail] - Optional detail or identifier of the page.
 * @param {string} [params.listingType] - Optional listing type (e.g., products, services).
 * @param {string} [params.boutiqueName] - Optional name of the boutique.
 * @param {string} [params.appointmentLine] - Optional appointment line information.
 * @param {string} [params.appointmentOccasion] - Optional occasion for the appointment.
 * @param {string} [params.appointmentDate] - Optional date of the appointment.
 * @param {string} [params.appointmentWishlist] - Optional wishlist ID for the appointment.
 */
export function analyticsDynamicPage({
    category,
    subCategory,
    pageDetail,
    listingType,
    boutiqueName,
    appointmentLine,
    appointmentOccasion,
    appointmentDate,
    appointmentWishlist,
}: DynamicPageParameters): void {
    const eventDetails = {
        pageCategory: category,
        pagesubCategory: subCategory,
        pageDetail: pageDetail,
        listingType: listingType,
        boutiqueName: boutiqueName,
        appointmentLine: appointmentLine,
        appointmentOccasion: appointmentOccasion,
        appointmentDate: appointmentDate,
        appointmentWishlist: appointmentWishlist,
    }

    // Remove keys with undefined values to keep the event payload clean
    Object.keys(eventDetails).forEach((key) => {
        if (eventDetails[key] === undefined) {
            delete eventDetails[key]
        }
    })

    analyticsLogEvent(eventName, eventDetails)
}
